// Instafeed Layout Override Script
// This script creates proper nested flexbox containers after page loads

(function() {
  'use strict';

  // Function to create custom instafeed layout
  function createCustomInstafeed() {
    const isMobile = window.innerWidth <= 768;
    
    const instafeedWrapper = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
    const instafeedContainer = document.querySelector('#insta-feed .instafeed-new-layout-container');
    
    if (!instafeedWrapper) {
      return; // Exit if instafeed not found
    }

    // Get all instafeed items and extract data
    const items = instafeedWrapper.querySelectorAll('.instafeed-new-layout-item');
    console.log(`Found ${items.length} instafeed items`);
    
    // Log the structure of the first item for debugging
    if (items.length > 0) {
      console.log('First instafeed item structure:', items[0]);
      console.log('First item HTML:', items[0].outerHTML);
      const firstImg = items[0].querySelector('img');
      console.log('First item img:', firstImg);
      console.log('First item onclick:', items[0].onclick);
      
      // Check if the item itself is clickable
      const computedStyle = window.getComputedStyle(items[0]);
      console.log('First item cursor:', computedStyle.cursor);
      console.log('First item pointer-events:', computedStyle.pointerEvents);
    }

    if (items.length === 0) {
      return; // Exit if no items found
    }

    // Extract image data from instafeed items and store original elements
    const imageData = Array.from(items).map((item, index) => {
      const img = item.querySelector('img');
      
      const data = {
        src: img ? img.src : '',
        alt: img ? img.alt : '',
        title: img ? img.title : '',
        originalItem: item, // Store reference to original item for click handling
        index: index
      };
      
      // Log the extracted data for debugging
      console.log(`Image ${index}:`, {
        src: data.src,
        alt: data.alt,
        title: data.title,
        originalItem: data.originalItem,
        hasClickHandler: item.onclick !== null || item.addEventListener !== undefined
      });
      
      return data;
    });

    // Hide the original instafeed visually but keep it accessible for clicks
    instafeedWrapper.style.setProperty('position', 'absolute', 'important');
    instafeedWrapper.style.setProperty('left', '-9999px', 'important');
    instafeedWrapper.style.setProperty('opacity', '0', 'important');
    instafeedWrapper.style.setProperty('pointer-events', 'none', 'important');
    instafeedWrapper.style.setProperty('z-index', '-1', 'important');

    // Create our custom layout
    const customLayout = document.createElement('div');
    customLayout.className = 'custom-instafeed-layout loading';
    customLayout.style.cssText = `
      width: ${isMobile ? '100%' : '1512px'} !important;
      max-width: ${isMobile ? '100%' : '1512px'} !important;
      max-height: ${isMobile ? 'none' : '605px'} !important;
      margin: 0 auto !important;
      display: flex !important;
      ${isMobile ? 'flex-direction: column !important;' : ''}
      gap: 12px !important;
    `;

    if (isMobile) {
      createMobileCustomLayout(customLayout, imageData);
    } else {
      createDesktopCustomLayout(customLayout, imageData);
    }

    // Insert our custom layout after the original
    instafeedWrapper.parentNode.insertBefore(customLayout, instafeedWrapper.nextSibling);
    
    // Show the custom layout with a smooth transition
    setTimeout(() => {
      customLayout.classList.remove('loading');
      customLayout.classList.add('loaded');
    }, 100);
  }

  function createDesktopCustomLayout(container, imageData) {
    // Column 1: Large image (397x397) + two small images below (193x194 each)
    const col1 = document.createElement('div');
    col1.style.cssText = `
      width: 397px !important;
      height: 605px !important;
      position: relative !important;
    `;
    
    // Column 2: Full height single image (339x604)
    const col2 = document.createElement('div');
    col2.style.cssText = `
      width: 339px !important;
      height: 604px !important;
      position: relative !important;
    `;
    
    // Column 3: Two small images (179x224 each) + large image below (372x371)
    const col3 = document.createElement('div');
    col3.style.cssText = `
      width: 372px !important;
      height: 605px !important;
      position: relative !important;
    `;
    
    // Column 4: Full height single image (339x604)
    const col4 = document.createElement('div');
    col4.style.cssText = `
      width: 339px !important;
      height: 604px !important;
      position: relative !important;
    `;
    
    // Create and add images to their containers with absolute positioning
    if (imageData[0]) {
      const img0 = createImageElement(imageData[0], '397px', '397px');
      img0.style.position = 'absolute';
      img0.style.top = '0px';
      img0.style.left = '0px';
      col1.appendChild(img0);
    }
    
    if (imageData[1]) {
      const img1 = createImageElement(imageData[1], '193px', '194px');
      img1.style.position = 'absolute';
      img1.style.top = '409px';
      img1.style.left = '0px';
      col1.appendChild(img1);
    }
    
    if (imageData[2]) {
      const img2 = createImageElement(imageData[2], '193px', '194px');
      img2.style.position = 'absolute';
      img2.style.top = '409px';
      img2.style.left = '204px';
      col1.appendChild(img2);
    }
    
    if (imageData[3]) {
      col2.appendChild(createImageElement(imageData[3], '339px', '604px'));
    }
    
    if (imageData[4]) {
      const img4 = createImageElement(imageData[4], '179px', '224px');
      img4.style.position = 'absolute';
      img4.style.top = '0px';
      img4.style.left = '0px';
      col3.appendChild(img4);
    }
    
    if (imageData[5]) {
      const img5 = createImageElement(imageData[5], '179px', '224px');
      img5.style.position = 'absolute';
      img5.style.top = '0px';
      img5.style.left = '193px';
      col3.appendChild(img5);
    }
    
    if (imageData[6]) {
      const img6 = createImageElement(imageData[6], '372px', '371px');
      img6.style.position = 'absolute';
      img6.style.top = '236px';
      img6.style.left = '0px';
      col3.appendChild(img6);
    }
    
    if (imageData[7]) {
      col4.appendChild(createImageElement(imageData[7], '339px', '604px'));
    }
    
    // Build the structure
    container.appendChild(col1);
    container.appendChild(col2);
    container.appendChild(col3);
    container.appendChild(col4);
  }

  function createMobileCustomLayout(container, imageData) {
    // Row 1: [col1] [col2] - 2 columns side by side
    const row1 = document.createElement('div');
    row1.style.cssText = `
      display: flex !important;
      gap: 12px !important;
      width: 100% !important;
      height: 235.42px !important;
    `;
    
    // Row 2: [col3] [col4] - 2 columns side by side  
    const row2 = document.createElement('div');
    row2.style.cssText = `
      display: flex !important;
      gap: 12px !important;
      width: 100% !important;
      height: 371.43px !important;
    `;
    
    // Create column containers with equal width
    const col1 = document.createElement('div');
    col1.style.cssText = `
      width: calc(50% - 6px) !important;
      height: 235.42px !important;
      position: relative !important;
    `;
    
    const col2 = document.createElement('div');
    col2.style.cssText = `
      width: calc(50% - 6px) !important;
      height: 235.42px !important;
      position: relative !important;
    `;
    
    const col3 = document.createElement('div');
    col3.style.cssText = `
      width: calc(50% - 6px) !important;
      height: 371.43px !important;
      position: relative !important;
    `;
    
    const col4 = document.createElement('div');
    col4.style.cssText = `
      width: calc(50% - 6px) !important;
      height: 371.43px !important;
      position: relative !important;
    `;
    
    // Add images to columns - each image fills its container
    if (imageData[0]) {
      col1.appendChild(createImageElement(imageData[0], '100%', '100%'));
    }
    
    if (imageData[1]) {
      col2.appendChild(createImageElement(imageData[1], '100%', '100%'));
    }
    
    if (imageData[2]) {
      col3.appendChild(createImageElement(imageData[2], '100%', '100%'));
    }
    
    if (imageData[3]) {
      col4.appendChild(createImageElement(imageData[3], '100%', '100%'));
    }
    
    // Build the structure
    row1.appendChild(col1);
    row1.appendChild(col2);
    row2.appendChild(col3);
    row2.appendChild(col4);
    
    container.appendChild(row1);
    container.appendChild(row2);
  }

  // Function to find the instafeed.js instance
  function findInstafeedInstance() {
    // Try different ways to find the instafeed instance
    console.log('Looking for instafeed instance...');
    
    // Log all window properties that might contain instafeed
    console.log('Window properties containing "insta":', Object.keys(window).filter(key => key.toLowerCase().includes('insta')));
    console.log('Window properties containing "feed":', Object.keys(window).filter(key => key.toLowerCase().includes('feed')));
    
    // Check window object for instafeed instances
    if (window.instafeed) {
      console.log('Found window.instafeed');
      return window.instafeed;
    }
    
    // Check for common instafeed variable names
    const possibleNames = ['instafeed', 'Instafeed', 'instaFeed', 'insta_feed', 'instaFeedInstance', 'instafeedInstance'];
    for (const name of possibleNames) {
      if (window[name]) {
        console.log(`Found window.${name}`);
        return window[name];
      }
    }
    
    // Check jQuery data if jQuery is available
    if (window.jQuery) {
      console.log('jQuery is available, checking for instafeed data...');
      const $instafeed = window.jQuery('#insta-feed');
      console.log('jQuery instafeed element:', $instafeed);
      if ($instafeed.length && $instafeed.data('instafeed')) {
        console.log('Found jQuery instafeed data');
        return $instafeed.data('instafeed');
      }
      
      // Check all data attributes
      console.log('All jQuery data attributes:', $instafeed.data());
    }
    
    // Check for instafeed in global scope
    if (typeof instafeed !== 'undefined') {
      console.log('Found global instafeed');
      return instafeed;
    }
    
    // Look for instafeed instances in common locations
    const instafeedContainer = document.querySelector('#insta-feed');
    if (instafeedContainer) {
      console.log('Instafeed container found:', instafeedContainer);
      console.log('Container properties:', Object.keys(instafeedContainer));
      
      // Check if instafeed instance is stored on the element
      if (instafeedContainer.instafeed) {
        console.log('Found instafeed on container element');
        return instafeedContainer.instafeed;
      }
      
      // Check for data attributes
      if (instafeedContainer.dataset.instafeed) {
        console.log('Found instafeed in dataset');
        return instafeedContainer.dataset.instafeed;
      }
      
      // Check all data attributes
      console.log('All data attributes:', instafeedContainer.dataset);
    }
    
    // Check if there are any global functions that might be instafeed related
    console.log('Global functions containing "insta":', Object.keys(window).filter(key => typeof window[key] === 'function' && key.toLowerCase().includes('insta')));
    
    console.log('No instafeed instance found');
    return null;
  }

  // Function to trigger click on original item with multiple methods
  function triggerOriginalItemClick(originalItem) {
    if (!originalItem) {
      console.log('No original item to click');
      return;
    }
    
    console.log('Attempting to click original item:', originalItem);
    
    // Look for the specific instafeed button element
    const instafeedButton = originalItem.querySelector('[data-instafeed-role-button="true"]');
    if (instafeedButton) {
      console.log('Found instafeed button element:', instafeedButton);
      console.log('Button data-instafeed-open-id:', instafeedButton.getAttribute('data-instafeed-open-id'));
      
      // Click the instafeed button
      try {
        instafeedButton.click();
        console.log('Clicked instafeed button successfully');
        return; // Success, exit early
      } catch (e) {
        console.log('Direct click on instafeed button failed:', e);
      }
      
      // Try dispatching click event on the button
      try {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          button: 0,
          buttons: 1,
          clientX: 0,
          clientY: 0
        });
        instafeedButton.dispatchEvent(clickEvent);
        console.log('Click event dispatched on instafeed button');
        return; // Success, exit early
      } catch (e) {
        console.log('Click event dispatch on instafeed button failed:', e);
      }
    } else {
      console.log('No instafeed button found in original item');
    }
    
    // Fallback: Try clicking the original item itself
    try {
      originalItem.click();
      console.log('Direct click on original item attempted');
    } catch (e) {
      console.log('Direct click on original item failed:', e);
    }
    
    // Fallback: Try dispatching click event on original item
    try {
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 0,
        buttons: 1,
        clientX: 0,
        clientY: 0
      });
      originalItem.dispatchEvent(clickEvent);
      console.log('Click event dispatched on original item');
    } catch (e) {
      console.log('Click event dispatch on original item failed:', e);
    }
  }

  function createImageElement(imageData, width, height) {
    const link = document.createElement('a');
    link.href = '#';
    link.style.cssText = `
      display: block !important;
      width: ${width} !important;
      height: ${height} !important;
      text-decoration: none !important;
      cursor: pointer !important;
    `;
    
    // Add click handler to trigger instafeed.js modal
    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Image clicked!', {
        imageData: imageData,
        originalItem: imageData.originalItem,
        index: imageData.index
      });
      
      // Try to find and use instafeed.js API
      const instafeedInstance = findInstafeedInstance();
      if (instafeedInstance) {
        console.log('Found instafeed instance:', instafeedInstance);
        
        // Try different methods to open the modal
        if (typeof instafeedInstance.openModal === 'function') {
          console.log('Using openModal method');
          instafeedInstance.openModal(imageData.index);
        } else if (typeof instafeedInstance.showModal === 'function') {
          console.log('Using showModal method');
          instafeedInstance.showModal(imageData.index);
        } else if (typeof instafeedInstance.open === 'function') {
          console.log('Using open method');
          instafeedInstance.open(imageData.index);
        } else if (instafeedInstance.modal && typeof instafeedInstance.modal.open === 'function') {
          console.log('Using modal.open method');
          instafeedInstance.modal.open(imageData.index);
        } else {
          console.log('No modal method found, trying to trigger click on original item');
          // Fallback to clicking original item
          triggerOriginalItemClick(imageData.originalItem);
        }
      } else {
        console.log('No instafeed instance found, trying to click original item');
        // Fallback to clicking original item
        triggerOriginalItemClick(imageData.originalItem);
      }
    });
    
    const img = document.createElement('img');
    img.src = imageData.src;
    img.alt = imageData.alt;
    img.title = imageData.title;
    img.style.cssText = `
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
      border-radius: 0 !important;
    `;
    
    link.appendChild(img);
    return link;
  }

  // Function to wait for instafeed to load
  function waitForInstafeed() {
    const checkInterval = setInterval(() => {
      const instafeedWrapper = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
      const items = document.querySelectorAll('#insta-feed .instafeed-new-layout-item');
      
      // Check if instafeed is loaded and has items
      if (instafeedWrapper && items.length > 0) {
        clearInterval(checkInterval);
        
        // Wait for page to fully load before creating custom layout
        setTimeout(() => {
          createCustomInstafeed();
        }, 500);
      }
    }, 500); // Check every 500ms

    // Stop checking after 30 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 30000);
  }

  // Start the process when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForInstafeed);
  } else {
    waitForInstafeed();
  }

  // Also listen for any dynamic content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('#insta-feed')) {
            setTimeout(createCustomInstafeed, 500);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Add resize handler to reapply styles when window is resized
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Recreate the custom layout on resize
      createCustomInstafeed();
    }, 250); // Debounce resize events
  });

})();
